import { render, staticRenderFns } from "./pos-price-edition-modal.vue?vue&type=template&id=4aa4368c&scoped=true&"
import script from "./pos-price-edition-modal.vue?vue&type=script&lang=ts&"
export * from "./pos-price-edition-modal.vue?vue&type=script&lang=ts&"
import style0 from "./pos-price-edition-modal.vue?vue&type=style&index=0&id=4aa4368c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa4368c",
  null
  
)

export default component.exports